exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".refresher {\n  margin-top: 4px;\n}\n.refresher .fa-refresh {\n  font-size: 75%;\n}\n.refresher .fa-refresh.refresh-disabled {\n  opacity: 0.5;\n}\n.refresher .fa-refresh.refresh-young {\n  color: var(--color-success);\n}\n.refresher .fa-refresh.refresh-old {\n  color: var(--color-alert);\n}\n.refresher .fa-refresh.refresh-ancient {\n  color: var(--color-danger);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/presentation/refresher/refresher.less
// module id = 2492
// module chunks = 0